/** Публичный демо-контур. Пароли только для витрины, не боевые. */
export const DEMO_SLUG = 'demo';
export const DEMO_MENU_PATH = `/menu/${DEMO_SLUG}`;
export const DEMO_HUB_HREF = `/demo.html?slug=${DEMO_SLUG}`;
export const DEMO_LOGIN_PATH = '/login?demo=1';
export const DEMO_ACCOUNTS = {
  admin: { email: 'demo@tez-hop.uz', password: 'TezHopDemo26', label: 'Админ' },
  kitchen: { email: 'kitchen.demo@tez-hop.uz', password: 'TezHopDemo26', label: 'Кухня' },
  courier: { email: 'courier.demo@tez-hop.uz', password: 'TezHopDemo26', label: 'Курьер' },
};
